export class Geocoding {
  constructor(
    public readonly lat: string,
    public readonly lng: string) {
  }
}
